<template>
  <div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'OidcCallback',
  methods: {
    ...mapActions([
      'oidcSignInCallback'
    ])
  },
  mounted () {
    console.log('oidc callback init') /* eslint-disable-line no-console */
    this.oidcSignInCallback()
      .then((redirectPath) => {
        console.log('oidc callback redirect: ' + redirectPath) /* eslint-disable-line no-console */
        this.$router.push(redirectPath)
      })
      .catch((err) => {
        console.error(err) /* eslint-disable-line no-console */
        this.$router.push('/accessdenied')
      })
  }
}
</script>